import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
    path: '/activityTicket',
    component: Layout2,
    meta: {zhtitle: zh.m.router.common.ACTIVITY_TICKET,jatitle: ja.m.router.common.ACTIVITY_TICKET},
    children: [{
        path: '',
        name: 'activityTicket',
        meta: {
            zhtitle: zh.m.router.common.ACTIVITY_TICKET,
            jatitle: ja.m.router.common.ACTIVITY_TICKET,
            pername: "activitys"
        },
        component: () => import(/* webpackChunkName: "jp.activityTicket" */ '@/merchanAdmin/activityTicket/list')
    }, {
        path: 'create',
        name: 'activityTicketCreate',
        meta: {
            zhtitle: zh.m.router.common.CREATE, jatitle: ja.m.router.common.CREATE, pername: "activitys"
        },
        component: () => import(/* webpackChunkName: "jp.activityTicket" */ '@/merchanAdmin/activityTicket/detail')
    }, {
        path: 'detail',
        name: 'detail',
        meta: {
            zhtitle: zh.m.router.common.EDIT, jatitle: ja.m.router.common.EDIT, pername: "activitys"
        },
        component: () => import( /* webpackChunkName: "jp.activityTicket" */ '@/merchanAdmin/activityTicket/detail')
    }]
}]
